;
// Шаблоны
const baseConfig = {
    kbSelector: {
        mainLoader: '#loader',
        header: '.kb-header',
        autoSaveButton: '.kb-content-autosave-button',
        autoSaveCheckbox: '.kb-content-autosave-button > input[type=checkbox]',
        autoSaveTextStatus: '.kb-content-autosave-text-status',
        historyButton: '.kb-content-history-button',
        historyContent: 'div.history-content',
        historyNotice: '.history-notice',
        editButton: '.kb-content-edit-button',
        saveButton: '.kb-content-save-button',
        shareButton: '.kb-content-share-button',
        printButton: '.kb-content-print-button',
        content: '.kb-content',
        page: '.kb-tree-node-page',
        pageContent: '.content .kb-page-content',
        pageHeader: '.content .kb-page-header',
        pageTextarea: '#page-content',
        pageHeaderInput: '#page-header-input',
        treeFavorite: '.tree-favorite',
        tree: '.tree',
        node: '.tree-node',
        section: '.section',
        sectionNode: '.tree-node.section',
        nodeIcon: '.tree-node-icon',
        nodeActive: '.tree-node.active',
        nodeTitle: '.tree-node-title',
        nodeMenu: '.tree-node-title  .node-menu-btn',
        nodeTitleText: '.tree-node-title > span',
        nodeButtons: '.tree-node-title-buttons',
        nodeAdd: '.tree-node-title-buttons.select  .kb-tree-node-add, .kb-header .kb-tree-node-add',
        nodeChildren: '.tree-node-children',
        nodeDragTo: '.kb-node-drag-to',
        breadcrumbs: '.breadcrumbs',
        breadcrumb: '.breadcrumbs-item',
        search: '.search input',
        searchForm: '.kb-search-form',
        searchItems: '.search-items',
        searchItem: '.search-item',
        searchPage: '.kb-search-result-page',
        searchResult: '.kb-search-result',
        searchResultContent: '.kb-search-result-content',
        searchClear: '.kb-search-clear',
        settings: '#settings',
        settingsButton: '.kb-settings-button',
        settingsSubmit: '.kb-settings-submit',
        rightsSubmit: '.kb-entity-rights-submit',
        settingsUsers: '#settings .kb-settings-user-row',
        settingsRadio: '#settings .kb-settings-user-row input[type="radio"]',
        settingsTableBody: 'table.settings-users tbody',
        entityPermUsers: '#settings .user-permission .kb-settings-user-row',
        entityPermRadio: '#settings .user-permission  .kb-settings-user-row input[type="radio"]',
        paymentNotice: '#payment-notice',
        successActivation: '#success-activation',
        clearButton: '.kb-clear-application',
        exportButton: '.kb-export-application',
        importButton: '.kb-import-application',
        importFile: 'input.kb-file-input',
        clearModal: '#modal-clear',
        historyModal: '#modal-history',
        importModal: '#modal-import',
        developerModal: '#modal-developer',
        importConfirm: '.kb-app-import-confirm',
        clearConfirm: '.kb-app-clear-confirm',
        clearBaseDemoContent: '.demo-content-checkbox input',
        deleteNode: '.tree-node-title-buttons.select .kb-tree-node-delete',
        sectionPermission: '.tree-node-title-buttons.select .kb-tree-node-permission',
        deleteContent: '.kb-content-delete-button',
        deleteModal: '#modal-delete-node',
        templatePage: '#tree-node-page-template',
        templateSearchResult: '#search-result-template',
        templateTreeNode: '#tree-node-template',
        templateTree: '#tree-template',
        templateSettings: '#settings-template',
        templatePaymentNotice: '#payment-notice-template',
        templateSuccessPaymentNotice: '#success-payment-notice-template',
        templateHistory: '#history-template',
        templateTagPanel: '#tag-panel-template',
        templateTag: '#tag-document-template',
        templateTagCatalog: '#tag-catalog-template',
        templateTagRow: '#tag-document-template',
        templateTagCloud: '#tag-cloud-template',
        templateDeveloper: '#developer-template',
        templateUpdatesLog: '#updates-log-template',
        userPermissionTemplate: '#user-permission-template',
        userPermissionTableRowTemplate: '#user-permission-table-row-template',
        noticeModal: '#modal-notice',
        templateNodeDraggable: '#tree-node-draggable-template',
        templateNodeDragTo: '#tree-node-drag-to-template',
        templateUserSelect: '#user-select-template',
        errorModal: '#modal-show-error',
        result: '#result',
        gotoUp: '.kb-goto-up',
        kbOpenKey: '#kbopenkey',
        activationKeyDataInput: '.kb-activation-key-data-input',
        activationKeyDataResult: '.kb-activation-key-data-result',
        activationKeyDataButton: '.kb-activation-key-data-button',
        successPaymentNoticeButton: '.kb-success-payment-notice-button',
        showActivationFormButton: '.kb-show-activate-form',
        showUpdateInfoButton: '.kb-show-update-info',
        noticeNode: '#modal-notice-node',
        permission: '#permission',
        csrfInput: '#csrf-token',
        favorite: '.favorite',
        favoriteButton: '.kb-content-favorite-button',
        favoriteNodeContainer: '.tree-node-favorite',
        favoriteNodeActive: '.tree-node.favorite.favorite-active',
        tagAddButton: '.kb-content-add-tag-button',
        tagDropdown: '.kb-content-add-tag-dropdown',
        tagDropdownSearch: '.tag-dropdown-search',
        tagDropdownNotice: '.tag-dropdown-notice',
        tagCatalog: '.tag-catalog',
        tagCatalogItem: '.tag-catalog-item',
        tagRow: '.kb-content-tag-row',
        tagRemoveButton: '.kb-tag-remove',
        tagBody: '.kb-tag-body',
        tagCloudPage: '.kb-tag-cloud-page',
        tagCloudButton: '.kb-tag-cloud-button',
        developerButton: '.kb-developer-button',
        lastModifiedWrapper: '.last-modified',
        lastModifiedContent: '.last-modified-data',
        templateDocumentTitle: '#document-title-input-template',
        templateDocumentPageContent: '#document-page-content-template',
        attachUsersSettingsLink: '.attach_users_settings_link',
        licenseButton: '.license-button',
        detachUsersButton: '.detach-users-button',
        licensingModal: '#modal-licensing',
        templateLicenseModal: '#licensing-template',
        templateLicenseInfo: '#license-key-info',
        activateKeyInput: '#activate-key-input',
        activateKeyButton: '#activate-key-button',
        authorChangeSelectContainer: '#author-change-select',
        authorChangeSelect: '#user-set-author',
        commentContainerSelector: '.comment-container',
        publishToActivityStreamButton: '.kb-content-publish-to-activity-stream-button',
        shareDocumentLinkButton: '.kb-content-share-document-link-button',
        publishToBaseBlogButton: '.kb-content-publish-to-base-blog-button',
        bx24CreateChatButton: '.kb-content-bx24-create-chat-button',
        documentTestsButton: '.kb-content-tests-button',
        templateDocumentView: '#document-view-template',
        documentViewCount: '.document-views-users-count',
        documentViewContent: '.document-view-content',
        templateDocumentReading: '#document-read-option-template',
        documentReadingOption: '.kb-document-reading-option',
        documentReadingButton: '#reading-button',
        documentUserReadingButton: '.kb-user-read-button',
        documentUserReadingMessage: '.kb-reading-message',
        documentReadersCount: '.document-readers-count',
        templateDocumentUserReading: '#document-read-button-template',
        documentReadUsersContent: '.kb-document-read-users',
        documentReadingContent: '.kb-reading-button',
        templateUserList: '#user-list-template',
        documentUserList: '.kb-document-user-list',
        documentUserName: '.document-user-name',
        documentUserSupply: '.kb-document-user-supply',
        templateDocumentReadersList: '#document-readers-list-template',
        templateDocumentReadersListTop: '#document-read-top-message-template',
        treeRegulation: '.tree-regulation',
        regulation: '.regulation',
        regulationButton: '.kb-content-regulation-button',
        regulationNodeContainer: '.tree-node-regulation',
        regulationNodeActive: '.tree-node.regulation.regulation-active',
        technicalNotification: '.technical-work-notice',
        technicalMessage: '.tn-title',
        technicalNotificationCloseBtn: '.tn-close-button',
    },
    kbOptions: {
        autosave: 'autosave',
        documentReading: 'doc_reading',
        regulation: 'regulation',
    },
    kbClass: {
        active: 'active',
        section: 'section',
        document: 'document',
        open: 'open',
        favorite: 'favorite',
        regulation: 'regulation',
        draggable: 'draggable',
        dragover: 'dragover',
        insertPosition: 'drag-insert-after',
        loading: 'loading',
        dragImage: 'draggable-image',
    },
    kbTemplates: {
        page: 'templatePage',
        search: 'templateSearchResult',
        tree: 'templateTree',
        settings: 'templateSettings',
        paymentNotice: 'templatePaymentNotice',
        successActivation: 'templateSuccessPaymentNotice',
        nodeDraggable: 'templateNodeDraggable',
        nodeDragTo: 'templateNodeDragTo',
        userPermission: 'userPermissionTemplate',
        userPermissionTableRow: 'userPermissionTableRowTemplate',
        history: 'templateHistory',
        node: 'templateTreeNode',
        tagCatalog: 'templateTagCatalog',
        tagRow: 'templateTagRow',
        tagCloud: 'templateTagCloud',
        developer: 'templateDeveloper',
        updatesLog: 'templateUpdatesLog',
        documentTitleInput: 'templateDocumentTitle',
        documentPageContentTextarea: 'templateDocumentPageContent',
        templateLicenseModal: 'templateLicenseModal',
        templateLicenseInfo: 'templateLicenseInfo',
        userSelect: 'templateUserSelect',
        readerList: 'templateDocumentReadersList',
    },
    jsConfig: {
        deleteHeaderColor: '#BD5B5B',
        gaKnowledgeBase: appName,
        gaSaveSetting: 'Сохранение настроек',
        gaChangeUserRight: 'Изменения настроек пользователя',
        gaOpenSetting: 'Открыта страница настроек',
        gaClearSetting: 'Произведен сброс настроек',
        gaMoveTreeNode: 'Перемещение узла дерева в раздел',
        gaDeleteSection: 'Удаление раздела',
        gaDeleteDocument: 'Удаление документа',
        gaCreateSection: 'Создание раздела',
        gaCreateDocument: 'Создание страницы',
        gaEditSection: 'Раздел открыт для редактирования',
        gaEditDocument: 'Документ открыт для редактирования',
        gaSaveSection: 'Сохранение раздела',
        gaSaveDocument: 'Сохранение страницы',
        gaOpenPage: 'Открыта страница',
        gaBreadcrumbClick: 'Переход по хлебной крошке',
        gaSearch: 'Отправка запроса формы поиска',
        gaImport: 'Импорт данных базы знаний',
        gaExport: 'Экспорт данных базы знаний',
        gaOpenHistory: 'Открыта история изменений',
        gaAddToFavorite: 'Документ добавлен в Избранное',
        gaDelFromFavorite: 'Документ убран из Избранного',
        gaAddToRegulation: 'Документ добавлен в Регламенты',
        gaDelFromRegulation: 'Документ убран из Регламентов',
        gaTagAttached: 'К документу прикреплен тег',
        gaTagRemoved: 'От документа откреплен тег',
        gaTagCloudPage: 'Открыто облако тегов',
        gaSearchByTag: 'Отправка запроса поиска документов по тегу',
        // Интервал проверки прав пользователя
        renderTreeInterval: 10000,
        // Интервал после ввода с клавиатуры, после которого покажутся результаты поиска
        searchInputDelay: 5000,
        // Минимальное количество символов для начала поиска
        searchMinSymbolsCount: 2,
        // Количество оставляемых до и после символов при обрезке
        searchSymbolPaddings: 200,
        // Интервал после ввода с клавиатуры, после которого покажутся результаты поиска
        nodeDragOverDelay: 1000,
        // Безопасный интервал между последовательными запросами
        safeRequestInterval: 2000,
        // Идентификатор отслеживания Google Analytics
        googleAnalyticsUA: 'UA-81211331-4',
        // Интервал автосохранения содержимого документа после изменения или ввода с клавиатуры
        autoSaveDelay: 10000,
        // Префикс пользовательских опций Битрикс
        bx24OptionPrefix: 'kb_',
        // Максимальная длина тега
        tagMaxLength: 80,
        // Автоматическое изменение размера фрейма в соответствии с размером содержимого
        autoFitEnabled: true,
        // Минимальная высота фрейма приложения при работе прелоадера
        minFrameHeight: 610,
        // Допустимая разница между высотой окна и минимизированной (рекомендуемой) высотой
        minimizeHeightDiff: 75,
        // Максимальное количество значений в ответе Bitrix API
        maxBx24Results: 50,
        // Установка временного промежутка в миллисекундах, через который будет осуществляться актуализация сессии
        sessionInterval: 60000,
        // Ключи localStorage
        lsKeys: {
            // Состояние узлов дерева
            treeState: 'treeState'
        },
        // Хэш для головного элемента - заголовка "Избранное"
        favoriteSectionHash: 'favorite_hash',
        //Хэш для головного элемента - заголовка "Регламенты"
        regulationSectionHash: 'regulation_hash',
        // Задается высота окна при редактировании
        tinyMceEditorHeight: 540,
        // Стиль кнопки публикации документа в блог
        baseBlogPostPublishedStyleClass: 'kb-base-blog-post-published',
        //
        baseBlogPostPublishedSelector: 'publish-to-blog',
    },
    /**
     * Ссылки на сайт и приложения разработчика
     *
     * @type {object}
     * @param name {string} - разработчик
     * @param urlTitle {string} - наименование вебсайта разработчика
     * @param url {string} - ссылка на вебсайт разработчика
     * @param appListUrlTitle {string} - название ссылки на список приложений
     * @param appListUrl {string} - ссылка на список приложений
     */
    developerInfo: {
        name: 'developer_name', // ключ в локализации components.base_show.developer
        urlTitle: 'https://infoservice.ru',
        url: 'https://infoservice.ru',
        appListUrlTitle: 'app_list_url_title', // ключ в локализации components.base_show.developer
        appListUrl: 'https://www.bitrix24.ru/apps/?partner_id=524714&search=Y',
        updatesInfoUrlTitle: 'more', // ключ в локализации components.base_show.developer
        updatesInfoUrl: 'https://atlas24.pro/update',
    },

    userList: null,
};

var serverUrl = document.location.host + (document.location.pathname.length > 0
    ? document.location.pathname : '');
    serverUrl = serverUrl.substr(0, serverUrl.lastIndexOf('/'));
// Счётчики новых документов и папок
var newDocumentCounter = 0,
    newFolderCounter = 0;

/**
 * Переменные пользователей и доступа
 */
// Может ли текущий пользователь редактировать
var isUserCanWrite = false;
// Является ли текущий пользователь админом
var isAdmin = false;
// Список пользователей
var userList;
// Интервал проверки прав
var checkRightsInterval;

// Контент статей
var kbContent = {};
// ID перемещаемого элемента дерева
var draggableNodeID;
// Является ли перемещаемый элемент разделом
var draggableNodeIsFolder;

var initRights = {
    U1: 'X',
    AU: 'R'
};
var auth = {};
var projectData = null;
var url = window.location.toString();

// Не всегда корректно обновлялось по F5
var refererUrl = new URL(document.referrer ? document.referrer : url);

export { baseConfig };
